import { render, staticRenderFns } from "./filter-box.vue?vue&type=template&id=6edec22e&scoped=true&"
import script from "./filter-box.vue?vue&type=script&lang=ts&"
export * from "./filter-box.vue?vue&type=script&lang=ts&"
import style0 from "./filter-box.vue?vue&type=style&index=0&id=6edec22e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edec22e",
  null
  
)

export default component.exports